/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc
 */

export const requestAccessRpc = {
  serviceName: 'com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc',
  rpcName: 'requestAccess',
  auth: 'app',
  fingerprint: '6R6x6gltlLfAnYmg62EWw7PWfbUk8Gb2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalNotificationSettingsRpc = {
  serviceName: 'com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc',
  rpcName: 'getPortalNotificationSettings',
  auth: 'app',
  fingerprint: 'UTR3bfSEA-gDPFAfYahTKfstfmuQzwcu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setPortalNotificationSettingsRpc = {
  serviceName: 'com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc',
  rpcName: 'setPortalNotificationSettings',
  auth: 'app',
  fingerprint: 'PuXic3NXz-pFgwXfeeHQ3vstfmuQzwcu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const queryAccessRequestByLocationRpc = {
  serviceName: 'com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc',
  rpcName: 'queryAccessRequestByLocation',
  auth: 'app',
  fingerprint: 'UZV3uiAbAqQooGoo1krKVrPWfbUk8Gb2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const queryAccessRequestsByUserIdRpc = {
  serviceName: 'com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc',
  rpcName: 'queryAccessRequestsByUserId',
  auth: 'app',
  fingerprint: 'B45VibhT6v07dSTctmImZbPWfbUk8Gb2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const rejectAccessRequestRpc = {
  serviceName: 'com.hubspot.permissionsmanagement.accessrequest.rpc.AccessRequestRpc',
  rpcName: 'rejectAccessRequest',
  auth: 'app',
  fingerprint: 'PAM2Qon08d6_1ExP-mSZdPIL-BQOBi1B',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};